<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.branches") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn :to="{ name: 'create' }" class="primary">
        <span>{{ $t("button.create") }}</span>
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="branches"
      class="table-row"
      dialogWidth="500"
    >
      <template v-slot="{item,index}">
        <td class="text-sm-center">{{item.name}}</td>
        <td class="text-sm-center">{{item.city}}</td>
        <td class="text-sm-center">{{item.email}}</td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="branches"
            :model-id="item.id"
            field="main"
            v-model="item.is_main"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <router-link :to="{ name: 'edit', params: { slug: item.slug } }">
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </router-link>

          <v-icon :title="$t('icon.delete')" @click="handleDelete(item, index)" small>mdi-delete</v-icon>
        </td>
      </template>
    </wrapping-table>
  </main>
</template>

<script>
export default {
  name: "Branches",
  data() {
    return {
      headers: ["name", "city", "email",'is_main', "actions"]
    };
  },
  methods: {
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    }
  }
};
</script>

